import { useFormik } from 'formik';
import { Button, Slider, UnstyledButton } from '@mantine/core';
import yup from '@/libs/yup.ts';
import useAKBStore from '@/pages/AKB/AKB.store.ts';

interface SearchSettingsFormProps {
    onClose?: () => void;
}

const PERCENTAGE_MULTIPLIER = 100;
const MIN_THRESHOLD = 0;
const MAX_THRESHOLD = 100;

const SearchSettingsForm = ({ onClose }: SearchSettingsFormProps) => {
    const scoreThreshold = useAKBStore((state) => state.scoreThreshold);
    const setScoreThreshold = useAKBStore((state) => state.setScoreThreshold);

    const formik = useFormik({
        initialValues: {
            threshold: scoreThreshold * PERCENTAGE_MULTIPLIER
        },
        validationSchema: yup.object({
            threshold: yup
                .number()
                .min(MIN_THRESHOLD)
                .max(MAX_THRESHOLD)
                .required()
        }),
        onSubmit(data) {
            setScoreThreshold(data.threshold / PERCENTAGE_MULTIPLIER);
            onClose?.();
        }
    });
    const handleCancel = () => {
        onClose?.();
    };

    return (
        <form
            autoComplete="off"
            className="flex flex-col gap-3"
            onSubmit={formik.handleSubmit}
        >
            <div className="text-xs font-semibold">Search threshold</div>
            <Slider
                className="mb-8"
                label={(value) => `${value}%`}
                marks={[
                    { value: 0, label: '0%' },
                    { value: 25, label: '20%' },
                    { value: 50, label: '50%' },
                    { value: 75, label: '75%' },
                    { value: 100, label: '100%' }
                ]}
                value={formik.values.threshold}
                onChange={(value) => {
                    formik.setFieldValue('threshold', value);
                }}
            />
            <div className="flex justify-between gap-2">
                <UnstyledButton
                    className="text-xs text-gray-6"
                    onClick={handleCancel}
                >
                    Cancel
                </UnstyledButton>
                <Button
                    disabled={!formik.dirty || formik.isSubmitting}
                    size="xs"
                    type="submit"
                >
                    Apply
                </Button>
            </div>
        </form>
    );
};

export default SearchSettingsForm;
